// @ts-nocheck
import { Button, TextField } from "@material-ui/core";
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import * as React from "react";
import { useForm } from "react-hook-form";

type NetworkState = "PENDING" | "SUCCEED" | "FAILED" | "IDLE";

// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
  const regex = /^09\d{9}$/;
  if (value) {
    if (!regex.test(value)) {
      return "شماره موبایل صحیح نمیباشد";
    }
    return true;
  }
};

export const SNToValidator = (SNFrom, SNTo) => {
  if (SNFrom && SNTo && SNFrom > SNTo) {
    return `باید بیشتر "از سریال نامبر از" باشد`;
  }
};

export const SNFromValidator = (SNFrom, SNTo) => {
  if (SNFrom && SNTo && SNFrom > SNTo) {
    return `باید کمتر "از سریال نامبر تا" باشد`;
  }
};

interface IFormInput {
  SNFrom: string;
  SNTo: string;
  marketerMobile: string;
  sellerMobile: string;
  sellerPrice: number;
}

export function LimoocardAssign() {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors,  isValid,  dirtyFields },
  } = useForm<IFormInput>({
    mode: "onChange",
    defaultValues: {
      SNFrom: null,
      SNTo: null,
      marketerMobile: null,
      sellerMobile: null,
      sellerPirce: null,
    },
  });

  const [errorMessages, setErrorMessages] = React.useState([]);
  const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");

  const validateAtLeastOneFilled = () => {
    const isInputField1Filled =
      dirtyFields.sellerMobile && !!getValues("sellerMobile");
    const isInputField2Filled =
      dirtyFields.marketerMobile && !!getValues("marketerMobile");

    if (!isInputField1Filled && !isInputField2Filled) {
      return "حداقل یا شماره فروشنده یا بازاریاب باید وارد شود";
    }
    return true;
  };

  const validateSellerMobileIfSellerPrice = () => {
    const isSellerPriceFieldFilled = !!getValues("sellerPrice");
    const isSellerMobileFieldFilled = !!getValues("sellerMobile");
    if (isSellerPriceFieldFilled && !isSellerMobileFieldFilled) {
      return "در کنار مبلغ فروشنده، شماره فروشنده هم باید ارسال شود";
    }
    return true;
  };

  const ERROR_MESSAGES_TRANSLATE = {
    "marketer-mobile-not-found": "شماره بازاریاب یافت نشد",
    "marketer-mobile-is-invalid": "شماره بازاریاب صحیح نمیباشد",
    "seller-mobile-not-found": "شماره فروشنده یافت نشد",
    "seller-mobile-is-invalid": "شماره فروشنده صحیح نمیباشد",
  };

  const onSubmit = async (data: IFormInput) => {
    setErrorMessages([]);
    let token: any = localStorage.getItem("credentials");
    const url = `${process.env.REACT_APP_LEMONADE_SERVER}/api/discounts/limoo-cards/bulk`;
    const patchData = {
      serialNumberFrom: data.SNFrom,
      serialNumberTo: data.SNTo,
      marketer: {
        mobileNumber: data.marketerMobile,
      },
      seller: {
        mobileNumber: data.sellerMobile,
        price: data.sellerPrice,
      },
    };

    try {
      setNetworkState("PENDING");
      const { data } = await axiosWithAuthInterceptor({
        url: url,
        data: patchData,
        method: "PATCH",
      });

      if (data.err) {
        throw data;
      }
      setNetworkState("SUCCEED");
    } catch (error) {
      if (error.err) {
        setErrorMessages([...error.err.details.messages]);
      }
      setNetworkState("FAILED");
    }
  };

  const validateSNTo = () => {
    return SNToValidator(watch("SNFrom"), watch("SNTo"));
  };

  const validateSNFrom = () => {
    return SNFromValidator(watch("SNFrom"), watch("SNTo"));
  };

  return (
    <>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("SNFrom", {
            required: true,
            valueAsNumber: true,
            validate: {
              checkOrder: validateSNFrom,
            },
          })}
          error={!!errors.SNFrom}
          helperText={errors.SNFrom ? errors.SNFrom.message : null}
          fullWidth
          label="از سریال نامبر"
          variant="outlined"
        />

        <TextField
          {...register("SNTo", {
            required: true,
            valueAsNumber: true,
            validate: {
              checkOrder: validateSNTo,
            },
          })}
          fullWidth
          error={!!errors.SNTo}
          helperText={errors.SNTo ? errors.SNTo.message : null}
          label="تا سریال نامبر"
          variant="outlined"
        />

        <TextField
          {...register("sellerMobile", {
            validate: {
              atLeastOneFilled: validateAtLeastOneFilled,
              sellerMobileIfSellerPrice: validateSellerMobileIfSellerPrice,
            },
          })}
          error={!!errors.sellerMobile}
          helperText={errors.sellerMobile ? errors.sellerMobile.message : null}
          fullWidth
          label="شماره موبایل فروشنده"
          variant="outlined"
        />
        <TextField
          {...register("sellerPrice", {
            valueAsNumber: true,
            sellerMobileIfSellerPrice: validateSellerMobileIfSellerPrice,
          })}
          error={!!errors.sellerPrice}
          helperText={errors.sellerPrice ? errors.sellerPrice.message : null}
          fullWidth
          label="قیمت فروشنده"
          variant="outlined"
        />
        <TextField
          {...register("marketerMobile", {
            validate: {
              atLeastOneFilled: validateAtLeastOneFilled,
            },
          })}
          error={!!errors.marketerMobile}
          helperText={
            errors.marketerMobile ? errors.marketerMobile.message : null
          }
          placeholder="09*********"
          fullWidth
          label="شماره موبایل بازاریاب"
          variant="outlined"
        />

        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
          ثبت
        </Button>


        {networkState === "SUCCEED" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ? (
            errorMessages.map((message) =>
              ERROR_MESSAGES_TRANSLATE[message] ? (
                <p>{ERROR_MESSAGES_TRANSLATE[message]}</p>
              ) : (
                <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
              )
            )
          ) : (
            <p>خطایی رخ داده لطفا مجددا تلاش نمایید</p>
          ))}
      </form>
    </>
  );
}
